import Header from "./Header";
import ViewHeader from "./ViewHeader";
import BackendPanel from "./BackendPanel";

export default {
  Header,
  ViewHeader,
  BackendPanel
};
